module.exports = __webpack_public_path__ + "static/media/nature4.afc61d29.jpeg";